import TranslationToneTrialPlaceholder from '@/shared/assets/images/translation-tone-trial.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';

const TRIAL_PLAN_CONTENT: ModalContent = {
  title: 'Translations that sound like you',
  bulletsHeader: '',
  buttonText: 'See plans with Prompting',
  content: {
    // Prompting is Enterprise-only in the redesigned paywall (Figma 6161:6393):
    // an empty list means no self-serve plans — only the Enterprise card is shown.
    allowedPlanNames: [],
    chip: {
      title: 'Get better translation control with Prompting and other Pro tools',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'teams with ongoing localization workflows.',
    },
    whatYouCanDo: {
      title: 'With Prompting:',
      bullets: [
        'Your tone carries across every language',
        'Less editing after every dub',
        'Content that feels written for that audience, not translated',
      ],
    },
  },
  features: [],
  media: {
    src: TranslationToneTrialPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: () => MixpanelEvents.trialFeatureUpsellModalUnlockClick({ feature: 'translationTone' }),
  mixpanelOpeningEvent: () => MixpanelEvents.trialFeatureUpsellModalShown({ feature: 'translationTone' }),
  subtitle:
    'Tell us the tone, audience, and context — and get a translation that fits your content, not just the words.',
};

export const TRANSLATION_TONE_CONTENT: LimitedFeatureContent = {
  trial: TRIAL_PLAN_CONTENT,
};
